/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortListPosition
 */
export interface PortListPosition {
    /**
     * 
     * @type {Array<number>}
     * @memberof PortListPosition
     */
    coordinates?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PortListPosition
     */
    type?: string;
}

/**
 * Check if a given object implements the PortListPosition interface.
 */
export function instanceOfPortListPosition(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortListPositionFromJSON(json: any): PortListPosition {
    return PortListPositionFromJSONTyped(json, false);
}

export function PortListPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortListPosition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'coordinates': !exists(json, 'coordinates') ? undefined : json['coordinates'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function PortListPositionToJSON(value?: PortListPosition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'coordinates': value.coordinates,
        'type': value.type,
    };
}

